// @flow
import React from 'react';
import Dotdotdot from 'react-dotdotdot';
import { DateUtil } from 'utils/DateUtil';
import { CallToAction } from 'components/atoms/callToAction';
import { useViewport } from 'components/templates/viewportProvider';
import type { EventDate, Venue } from 'types/event';
import { isEmpty } from 'lodash';
import { CURRENT_COUNTRY_CODE } from 'config/env';
import { CountryTimeUtil } from 'utils/CountryTimeUtil';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  data: {
    title: string,
    subTitle?: string,
    imageUrl: string,
    venue?: Venue,
  },
  onClick: () => void,
  from: string,
};

export const EventCardMobile = (props: Props) => {
  const { height } = useViewport();
  const { data, from, ctaText } = props;

  if (!data) {
    return null;
  }

  const { venue } = data;
  const eventDates = venue?.eventDates || [];
  const countryCode = CURRENT_COUNTRY_CODE === '+1' ? 'USA' : 'INDIA';
  const validEventDates = CountryTimeUtil.filterValidEvents(eventDates, countryCode, false);


  const sortDates =
    from === 'upcoming' && !isEmpty(validEventDates)
      ? validEventDates.sort(function(a, b) {
          return new Date(a.date) - new Date(b.date);
        })
      : {};

  const eventDate: EventDate | undefined = sortDates.length > 0 ? sortDates[0] : undefined;

  const displayDate =
    from === 'upcoming'
      ? DateUtil.getShortDisplayDateFromISOString(eventDate?.date)
      : '';

  return (
    <div className={'event-card-mobile'} style={{ height }}>
      <div className={'content'}>
        <h1>{displayDate}</h1>
        <img src={data.imageUrl} alt={'Event Image'} />
        <div className={'event-info'}>
          <div className={'event-header'}>
            <Dotdotdot clamp={2} tagName={'h2'}>
              {data.title}
            </Dotdotdot>
            <span>{data.subTitle}</span>
          </div>
          <div className={'event-content'}>
            {from === 'upcoming' && (
              <p>
                {eventDate?.startTime}{' '}
                {eventDate?.endTime ? `to ${eventDate?.endTime}` : 'onwards'}{' '}
              </p>
            )}
            {venue && (
              <>
                <p>{venue.name}</p>
                <p>{venue.location}</p>
              </>
            )}
          </div>
          <CallToAction
            text={ctaText}
            onClick={props.onClick}
            mode={'transparent'}
            type={'small'}
            isMobile={true}
          />
        </div>
      </div>
    </div>
  );
};
